import { useSelector } from "react-redux";
import { IRootState } from "../../../redux/slices";
import { UserDetails } from "../../../redux/modules/client/userDetails";

export const useGetLoggedInUserDetails = () => {
  const loggedInUser: UserDetails | undefined = useSelector(
    (state: IRootState) => state?.auth?.authenticatedUserSlice?.loggedInUserDetails,
  );

  return {
    loggedInUser,
  };
};
